var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_10589)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43652 12.6873C7.43652 12.3652 7.69774 12.104 8.01986 12.104H12.6865C13.0087 12.104 13.2699 12.3652 13.2699 12.6873C13.2699 13.0095 13.0087 13.2707 12.6865 13.2707H8.01986C7.69774 13.2707 7.43652 13.0095 7.43652 12.6873Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1139 1.01285C10.4111 0.622674 9.55887 0.635554 8.86785 1.04652C8.64846 1.177 8.44593 1.37139 8.19095 1.64196C8.08245 1.75702 8.02826 1.81455 8.02931 1.88552C8.03036 1.95649 8.08683 2.01297 8.19982 2.12595L11.9281 5.85417C12.0434 5.96955 12.1011 6.02725 12.1734 6.02736C12.2456 6.02754 12.3028 5.97084 12.4172 5.85744C12.6627 5.61409 12.8406 5.4168 12.9616 5.20437C13.3604 4.50466 13.3727 3.64437 12.9944 2.93322C12.8367 2.6368 12.5711 2.36566 12.1742 1.96051L12.0669 1.8508C11.6714 1.44653 11.4055 1.17471 11.1139 1.01285Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0741 7.15389C11.1949 7.03745 11.2554 6.97924 11.2561 6.9058C11.2568 6.83235 11.1974 6.77303 11.0787 6.65432L7.42818 3.00377C7.30719 2.88277 7.2467 2.82226 7.17215 2.82376C7.0976 2.82524 7.03956 2.88812 6.92348 3.01388L2.41671 7.89676C1.76334 8.60446 1.36289 9.03817 1.12847 9.57775C0.89451 10.1162 0.848438 10.7087 0.773107 11.6775L0.772978 11.6792C0.772838 11.6809 0.723109 12.3171 0.730786 12.4549C0.739477 12.6109 0.77663 12.8006 0.921419 12.9649C1.06751 13.1307 1.25218 13.1903 1.40766 13.2162C1.54289 13.2388 2.152 13.2547 2.15323 13.2547C3.2599 13.2838 3.94401 13.3019 4.57312 13.0561C5.20133 12.8108 5.69778 12.3324 6.5033 11.5563L11.0741 7.15389Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_10589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.c4ea23e9578a2716253cc3fa59239e66.svg";
export { ForwardRef as ReactComponent };